import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-common-footer',
  templateUrl: './common-footer.component.html',
  styleUrls: ['./common-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommonFooterComponent implements OnInit {

  constructor(
    private commonService: CommonService,
    private router: Router
  ) { }

  isSafariMobile: boolean = true
  public categories: any = []

  ngOnInit(): void {
    // Init Category
    this.commonService.categoryList.subscribe((response) => {
      //console.log("repsonse", response)
      this.categories = response
    })
    // this.isSafariMobile = /iPhone|iPad|iPod/.test(navigator.userAgent) && /Safari/.test(navigator.userAgent);
  }

  navigateToCategory(category: any, sub: any = null) {
    const queryParams: any = { cat: category.slug };
    if (sub) {
      queryParams.subCat = sub.slug;
    }
    this.router.navigate(['/map'], { queryParams: queryParams });
  }

}
